import React, { useContext } from "react";
import "./singlestyles.scss";
import { EleveType } from "../../../../types/GlobalType";
import { eleveContext } from "../../../../context/AppContext";

const ParentInfoEleve = () => {
  const eleveData: EleveType = useContext(eleveContext);
  console.log(eleveData);

  return (
    <div className="tuteur_info">
      <h4 className="title_section">Information du tuteur</h4>
      <table>
        <tr>
          <td>Nom:</td>
          <td>{eleveData.parentNom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Post-Nom:</td>
          <td>{eleveData.parentPostNom?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Genre:</td>
          <td>
            {eleveData.parentSexe?.toUpperCase() === "F"
              ? "FEMININ"
              : "MASCULIN"}
          </td>
        </tr>
        <tr>
          <td>Contact:</td>
          <td>{eleveData.parentPhone?.toUpperCase()}</td>
        </tr>
      </table>
      <h4 className="title_section_2">Résidence</h4>
      <table>
        <tr>
          <td>Avenue:</td>
          <td>{eleveData.parentAvenue?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Quartier:</td>
          <td>{eleveData.parentQuartier?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Commune:</td>
          <td>{eleveData.parentCommune?.toUpperCase()}</td>
        </tr>
        <tr>
          <td>Ville:</td>
          <td>{eleveData.parentVille?.toUpperCase()}</td>
        </tr>
      </table>
    </div>
  );
};

export default ParentInfoEleve;
